import FilterNav from '../../molecules/filterNav/FilterNav';
import Slider from '../../atoms/slider/Slider';
import styles from './PriceMobileItem.module.scss';
const VoiceMobileItem = (props) => {

	const onSliderChange = (value) => {
		props.selectVMMobile(value);
	}
	return (
		<div className={styles.navGutter}>
			<FilterNav headingName='Voice minutes' 
						backbtn={props.hideVoiceMinutes} 
						resetClickHandler={props.resetClickHandler} 
						selectedFilter={props.selectedFilter}/>
			<div className={styles.priceContainer}>
				<div className={styles.slider}>
					<Slider sliderChange={(value) => onSliderChange(value)} label1 = "min"
						minValue={props.minValue}
						maxValue={props.maxValue}
						min={props.min}
						max={props.max}
						rightLabel ="min"
						sliderType ={"Voice" || "vm"}
						unlimited="vm" />
				</div>
			</div>
		</div>
	);
};

export default VoiceMobileItem
